import React from 'react';
import PropTypes from 'prop-types';
import { startsWith } from 'lodash';
import { scrollToElement } from '@sparefoot/react-core/utils/scrolling';

import Button from './Button';

export default function ScrollButton({ href, offset, onClick, ...rest }) {
	const handleClick = (event) => {
		if (startsWith(href, '#')) {
			event.preventDefault();
			scrollToElement(href, { offset });
		}
		if (onClick) onClick(event);
	};
	return (
		<Button
			{...rest}
			href={href}
			onClick={handleClick}
		/>
	);
}

ScrollButton.propTypes = {
	href: PropTypes.string,
	offset: PropTypes.number,
	onClick: PropTypes.func,
};
